export const QUERY_STALE_TIME_MS = 60 * 1000;
const TRUST_SECTION_CHECKMARK_ICON_DIAMETER_PIXELS = Number("22");
const CAPABILITY_CARD_ICON_DIAMETER_PIXELS = Number("34");

export const TRUST_CHECK_ICON_SIZE_PX = TRUST_SECTION_CHECKMARK_ICON_DIAMETER_PIXELS;
export const CAPABILITY_CARD_ICON_SIZE_PX = CAPABILITY_CARD_ICON_DIAMETER_PIXELS;